import React, { forwardRef, useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";

import { StyledForm, AccordionContent } from "./container.style";
import Accordion from "../../../formComponents/accordion/accordion.component";
import Section from "../../../formComponents/section/section.component";
import { Button } from "@mbo/forms";
import inputTypes from "../../../formComponents/formFields/constants";

const Form = forwardRef(({ structure, onPostForm, serverErrors }, ref) => {
  const { items } = structure;
  const defaults = Object.fromEntries(
    items.map((item) => [item.fields.name, item.fields.default]),
  );
  const [openedAccordion, setOpenedAccordion] = useState(0);
  const formMethods = useForm({
    mode: "onSubmit",
    defaultValues: {
      ...defaults,
    },
  });

  const { reset, setError } = formMethods;

  useEffect(() => {
    const { items } = structure;
    reset({
      ...Object.fromEntries(
        items.map((item) => [item.fields.name, item.fields.default]),
      ),
    });
  }, [structure, reset]);

  useEffect(() => {
    if (!serverErrors) return;
    Object.entries(serverErrors).forEach(([key, errs]) =>
      setError(key, { type: "manual", message: errs.join(", ") }),
    );
  }, [serverErrors, setError]);

  const renderSections = (sections) =>
    sections.map((section, idx) => <Section key={idx} data={section} />);

  const renderForm = structure.accordion ? (
    Object.entries(items).map(([label, sections], idx) => (
      <Accordion
        key={idx}
        idx={idx}
        title={label}
        isOpen={idx === openedAccordion}
        setIsOpen={() => setOpenedAccordion(idx)}
      >
        <AccordionContent>{renderSections(sections)}</AccordionContent>
      </Accordion>
    ))
  ) : (
    <AccordionContent>{renderSections(structure.items)}</AccordionContent>
  );

  const postAndTransformForm = (data) => {
    const booleanRadios = items
      .filter(
        (item) =>
          item.fields.type === inputTypes.RADIO &&
          item.fields.options.every((opt) => typeof opt.value === "boolean"),
      )
      .map((item) => item.fields.name);
    booleanRadios.forEach((item) => {
      if (item in data) data[item] = JSON.parse(data[item]);
    });
    onPostForm(data, reset);
  };
  return (
    <FormProvider {...formMethods}>
      <StyledForm
        ref={ref}
        onSubmit={formMethods.handleSubmit(postAndTransformForm)}
      >
        {renderForm}
        <hr />
        <AccordionContent className="button-container">
          <Button variant="action" round type="submit" size="xl">
            Submit
          </Button>
        </AccordionContent>
      </StyledForm>
    </FormProvider>
  );
});
Form.displayName = "Form";

export default Form;
